import api from '../api';

export const verificationService = {
    // getVerifications
    getVerifications: async (schoolId) => {
        try {
            const response = await api.get(`schools/${schoolId}/verification-requests`);
            return response.data;
        } catch (error) {
            console.error('Error getting verification list:', error);
            throw error;
        }
    },

    // Request verification from a school
    requestVerification: async (schoolId) => {
        try {
            const response = await api.post('/verifications/request', { schoolId });
            return response.data;
        } catch (error) {
            console.error('Error requesting verification:', error);
            throw error;
        }
    },

    // Get verification status
    getVerificationStatus: async () => {
        try {
            const response = await api.get('/verifications/status');
            return response.data;
        } catch (error) {
            console.error('Error getting verification status:', error);
            throw error;
        }
    },

    //For teacher to cancel verification request
    cancelVerification: async (verificationId) => {
        try {
            const response = await api.post(`/verifications/cancel`);
            return response.data;
        } catch (error) {
            console.error('Error canceling verification:', error);
            throw error;
        }
    },

    // For schools - approve verification request
    approveVerification: async (verificationId) => {
        console.log('approving verification', verificationId);
        try {
            const response = await api.post(`/verifications/${verificationId}/approve`);
            return response.data;
        } catch (error) {
            console.error('Error approving verification:', error);
            throw error;
        }
    },

    // For schools - reject verification request
    rejectVerification: async (verificationId) => {
        try {
            const response = await api.post(`/verifications/${verificationId}/reject`);
            return response.data;
        } catch (error) {
            console.error('Error rejecting verification:', error);
            throw error;
        }
    },

    // Get verification details
    getVerificationDetails: async (verificationId) => {
        try {
            const response = await api.get(`/verifications/${verificationId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting verification details:', error);
            throw error;
        }
    },

    // For schools - revoke verification request
    revokeVerification: async (verificationId) => {
        try {
            const response = await api.post(`/verifications/${verificationId}/revoke`);
            return response.data;
        } catch (error) {
            console.error('Error revoking verification:', error);
            throw error;
        }
    }
};
